import React from 'react'
import Shimmer from './Shimmer'
import SkeletonElement from './SkeletonElement'

const SkeletonTransaction = ({ theme }: any) => {
  const themeClass = theme || 'light'

  return (
    <div className={`skeleton-wrapper ${themeClass}`}>
      <div className="skeleton-article">
        <SkeletonElement type="transaction" />
      </div>
      <Shimmer />
    </div>
  )
}

export { SkeletonTransaction }
